module.exports = __webpack_public_path__ + "static/media/nuyir.36cae94a.png";